import styled from '@emotion/styled'

/**
 * AvailableResultStep — 수거 가능 결과 화면 (Figma 16392:29305).
 *
 * Layout:
 *  - BodyContent (flex 1, justify-between) — 위 TopGroup + 아래 BottomLinkButton
 *  - BottomNav (shrink-0) — 페이지 최하단 sticky 영역, 검정 CTA
 */

// ─── 본문 ────────────────────────────────────────────────

export const BodyContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 48px 20px 24px;
`

export const TopGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`

export const InstructionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`

export const Headline = styled.p`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.42px;
  color: #1f1f1f;
  text-align: center;
`

export const AddressRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px;
`

export const AddressChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid #e4e5e7;
  border-radius: 9999px;
  background: #ffffff;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.075px;
  color: #1b1c1d;
`

export const AddressSuffix = styled.span`
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.075px;
  color: #acaeb4;
`

/**
 * 본문 영역 끝 — "서비스 가능 지역 보기" 보조 링크.
 * BodyContent 의 justify-between 으로 TopGroup 과 떨어져 본문 하단에 위치 (Figma 18338:214700).
 */
export const BottomLinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border: 0;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #888888;
  text-decoration: underline;
  cursor: pointer;

  &:active {
    opacity: 0.7;
  }
`

// ─── 하단 CTA ────────────────────────────────────────────

/**
 * 페이지 최하단 sticky 영역 (Figma 16392:29323 Bottom Navigation).
 *
 * `position: sticky; bottom: 0` 으로 ResultWrapper(overflow-y: auto) 안에서 화면 하단 고정.
 * BodyContent 가 viewport 초과해도 CTA 항상 노출 보장 (작은 화면 / 키보드 케이스 안전망).
 *
 * iOS home indicator 영역 — safe-bottom 으로 보정.
 */
export const BottomNav = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 12px 16px calc(8px + var(--safe-bottom, 0px));
  background: #ffffff;
  z-index: 1;
`

/**
 * "수거 신청하기" CTA — Figma 기준 검정 (#1b1c1d / fg/inverse 토큰).
 * UnavailableResultStep 의 오렌지 CTA 와 별개 디자인.
 */
export const CtaButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  min-height: 32px;
  max-height: 60px;
  padding: 12px 32px;
  background: #1b1c1d;
  color: #ffffff;
  border: 0;
  border-radius: 16px;
  font-size: 17px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.17px;
  cursor: pointer;

  &:active {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
